import { ApiCommunications, NullPromise } from '../../../webmodule-common/interop/webmodule-interop';
import { DataCacheBase } from '../../../webmodule-common/cache/data-cache-base';
import { ItemReference } from '../../../webmodule-common/cache/definitions/cache-item-reference';
import { PaymentProfileCacheData } from './cache-data';
import {
  RequestGetClientDefaultPaymentProfileListByIds,
  ResultGetClientDefaultPaymentProfileListByIds
} from '../../api/dealer-api-interface-franchisee';

export class PaymentProfileCache extends DataCacheBase<PaymentProfileCacheData> {
  constructor(api: ApiCommunications) {
    super(api);
    //depending on what high level controller api we create we could swap this to ClientApi etc.
  }

  //override;
  protected async internalFetch(requestIds: string[]): NullPromise<ItemReference<PaymentProfileCacheData>[]> {
    if (requestIds.length == 0) return null;

    const input: RequestGetClientDefaultPaymentProfileListByIds = {
      paymentProfileIds: requestIds
    };
    const result = await this.api.post<ResultGetClientDefaultPaymentProfileListByIds>(
      `api/Franchisee/GetClientDefaultPaymentProfileListByIds`,
      input
    );
    if (!result) return null;

    return result.profiles.map(paymentProfile => {
      const data: PaymentProfileCacheData = { paymentProfile: paymentProfile };
      const qcr: ItemReference<PaymentProfileCacheData> = {
        id: paymentProfile.id,
        displayValue: `${paymentProfile.name}`,
        data: data,
        onClick: null
      };
      return qcr;
    });
  }
}
